import { render, staticRenderFns } from "./CleanButton.vue?vue&type=template&id=1c947043&"
import script from "./CleanButton.vue?vue&type=script&lang=js&"
export * from "./CleanButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports